import { useMemo, useState } from "react";
import { CurveArrow } from "components/atoms/Icon";

// import BrandImage1 from "assets/Images/BrandImage1.png";

import moment from "moment";
import BlurredImage from "components/atoms/BlurredImage";
import MagnetPriceInfoWidget from "pages/BrandPublicProfile/MagnetPriceInfoWidget";
import { useDeviceType } from "components/hooks";
import clsx from "clsx";
import BrandControlMagnetEligibilityModal from "./BrandControlMagnetEligibilityModal";
import { SPECIAL_RENDRING_BRAND_IDS } from "../../constants";

function MagnetPublicView({
  magnetDetails,
  refetchMagnetDetails,
  handleMagnetBuy,
  isMagnetDetailsRefetching,
  restrictMagnetClaim,
  isMagnetOwnedByUser,
  handleClaimMagnet,
}: {
  magnetDetails: PublicMagnet;
  refetchMagnetDetails: () => Promise<any>;
  handleMagnetBuy: any;
  isMagnetDetailsRefetching: any;
  restrictMagnetClaim: boolean;
  isMagnetOwnedByUser: boolean;
  handleClaimMagnet: () => void;
}) {
  const [isEligibilityCheckModalOpen, setIsEligibilityCheckModalOpen] = useState(false);
  const { isMobile } = useDeviceType(1024);

  const isCutomizedUIBrand = useMemo(
    () => SPECIAL_RENDRING_BRAND_IDS.includes(magnetDetails.brand_id),
    [magnetDetails.brand_id],
  );

  const handleEligibilityCheckClick = () => {
    setIsEligibilityCheckModalOpen(true);
  };

  return (
    <>
      {/* // <div className="grid grid-cols-12 gap-x-10 gap-y-8 bg-primary font-sora text-white"> */}
      {/* Magnet Image, Brand Details, Sale Widget */}
      {/* Magnet Details */}

      <div className="order-1 col-span-5 object-cover  md:h-full md:w-full lg:col-span-3  ">
        <div className="aspect-h-1 aspect-w-1 w-full ">
          <BlurredImage
            imageHash={magnetDetails.image_hash || null}
            alt={`${magnetDetails.name}`}
            src={magnetDetails.image_url}
            imageContainerClasses="h-full w-full rounded border border-white object-cover"
          />
        </div>
      </div>

      <div className="magnet-info-container order-3  col-span-12 lg:order-2 lg:col-span-6 ">
        {/* Brand Details */}
        <div
          className={clsx(
            "h-full flex-col justify-end space-x-2 space-y-4",
            isCutomizedUIBrand ? "text-primary" : "text-white",
          )}
        >
          <div className="hidden items-center space-x-2 font-satoshi text-xxs font-medium text-secondary lg:flex xl:text-xs">
            <CurveArrow className="aspect-1 w-3 md:w-4" />
            <p className={clsx(isCutomizedUIBrand ? "text-primary" : "text-white", "opacity-50")}>
              {"Launched on "}
              {moment(magnetDetails.created_at).format("MMMM D, YYYY")}
            </p>
            {/* <EllipsisHorizontalIcon className="text-red h-8 w-8 cursor-pointer " onClick={workInProgressAlert} /> */}
          </div>
          <div className="text-clay-brown hidden text-2xl font-semibold leading-snug first-letter:uppercase md:text-3xl lg:block 2xl:text-4xl">
            <h2>{magnetDetails.name}</h2>
          </div>
          <div className="mt-2 grow">
            <p className="whitespace-pre-line text-base leading-relaxed opacity-70 md:text-xxs xl:text-xs">
              {magnetDetails.magnetized_because}
            </p>
          </div>
        </div>
      </div>
      {isEligibilityCheckModalOpen && magnetDetails.type === 1 && (
        <BrandControlMagnetEligibilityModal
          brandId={magnetDetails.brand_id}
          magnetId={magnetDetails.id}
          membershipConditions={magnetDetails.membership_conditions}
          magnetPrice={"price" in magnetDetails.release ? magnetDetails.release.price : 100}
          handleMagnetPurchase={
            "price" in magnetDetails.release && magnetDetails.release.price === 0 ? handleClaimMagnet : handleMagnetBuy
          }
          onClose={() => setIsEligibilityCheckModalOpen(false)}
        />
      )}
      <div className="order-2 col-span-7 lg:order-3 lg:col-span-3 lg:my-4">
        <MagnetPriceInfoWidget
          isCustomizedUIBrand={isCutomizedUIBrand}
          handleClaimMagnet={handleClaimMagnet}
          isMagnetPageVariant
          refetchMagnetDetails={refetchMagnetDetails}
          isMagnetOwnedByUser={!!isMagnetOwnedByUser}
          handleMagnetBuy={handleMagnetBuy}
          isInteractionBlocked={!!magnetDetails.is_magnet_interaction_blocked}
          variant={isMobile ? 0 : 1}
          magnetName={magnetDetails.name}
          release={magnetDetails.release}
          magnetType={magnetDetails.type}
          // Magnet Claim is restricted if it is an event exclusive magnet and URL doesn't have the specific event id
          restrictMagnetClaim={!!restrictMagnetClaim}
          isMagnetDetailsRefetching={isMagnetDetailsRefetching}
          handleEligibilityCheckClick={handleEligibilityCheckClick}
        />
      </div>
    </>
  );
}
export default MagnetPublicView;
